import type { MaybeRefOrGetter } from 'vue';

interface LoggedFailureOptions {
  error: MaybeRefOrGetter<unknown>;
  message: string;
  context?: Record<string, unknown>;
}

/**
 * Log a data fetch's failure once: on the server, or on the client only after hydration (the
 * hydrated error ref would otherwise report the same server failure a second time).
 */
export const useLoggedFailure = ({ error, message, context }: LoggedFailureOptions) => {
  const nuxtApp = useNuxtApp();

  watchEffect(() => {
    const failure = toValue(error);
    if (failure && (import.meta.server || !nuxtApp.isHydrating)) {
      nuxtApp.$logErrorMessage(message, { error: failure, ...context });
    }
  });
};
